import { RiInformationFill } from 'react-icons/ri';
import { useState, useEffect } from 'react';
import { SeeAll } from './SeeAll';
import axios from 'axios';
import { Currencies } from './Currencies';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import ReactLoading from 'react-loading';
import { getToken } from '../utils';

function CurrencyConverter() {
  const { token: userToken } = getToken();
  const { currencys } = Currencies();
  // let defaultCurrencyBase;
  // let defaultCurrencyQuote;
  // for (let i = 0; i < currencys?.length; i++) {
  //   if (currencys[i].symbol === 'USD') {
  //     defaultCurrencyBase = currencys[i].id;
  //   } else if (currencys[i].symbol === 'EUR') {
  //     defaultCurrencyQuote = currencys[i].id;
  //   }
  // }

  // const [isLoading, setIsLoading] = useState(false);

  const defaultCurrencyBase = currencys.find(
    (currency) => currency.symbol === 'USD'
  )?.id;
  const defaultCurrencyQuote = currencys.find(
    (currency) => currency.symbol === 'EUR'
  )?.id;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [exchangeRate, setExchangeRate] = useState([]);
  const [inputs, setInputs] = useState({
    from: '',
    from_currency: '',
    to: '',
    to_currency: '',
  });

  // const navigate = useNavigate();

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  inputs.from_currency = inputs.from_currency
    ? inputs.from_currency
    : defaultCurrencyQuote;
  inputs.to_currency = inputs.to_currency
    ? inputs.to_currency
    : defaultCurrencyBase;

  useEffect(() => {
    if (
      inputs.from_currency === '' ||
      inputs.to_currency === '' ||
      inputs.from === ''
    ) {
      return;
    }
    const fetchData = async () => {
      try {
        setIsSubmitting(true);
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/exchange-rates/get-rate`,
          {
            base_currency_id: inputs.to_currency,
            quote_currency_id: inputs.from_currency,
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        setExchangeRate(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsSubmitting(false);
      }
    };
    fetchData();
  }, [
    defaultCurrencyBase,
    defaultCurrencyQuote,
    inputs.from,
    inputs.from_currency,
    inputs.to_currency,
    userToken,
  ]);

  return (
    <div className='flex w-full flex-col gap-4'>
      <SeeAll name='Convert Currency' seeAll={false} />

      <form className='flex flex-col gap-6 w-full box-border shadow-lg rounded-lg py-8 px-6 bg-p-wh'>
        <div className='w-full flex items-center lg:items-end flex-col lg:flex-row gap-6'>
          <div className=' w-full flex flex-col gap-2'>
            <label className='text-p-bk text-base font-pin'>From</label>
            <div className='relative items-center w-full h-12 rounded-lg border-t-bk border-[1px]'>
              <input
                type='number'
                className='focus:outline-none focus:ring focus:b-mc w-full px-2 h-11 rounded-lg'
                name='from'
                value={inputs.from}
                onChange={handleChange}
                placeholder='0.00'
                required
              />

              <select
                name='from_currency'
                className='focus:outline-none focus:ring focus:b-mc px-2 h-11 rounded-lg absolute right-0'
                value={
                  // inputs.from_currency
                  //   ? Number(inputs.from_currency)
                  //   : (inputs.from_currency = defaultCurrencyBase)
                  inputs.from_currency
                }
                onChange={handleChange}
                required
              >
                {currencys?.map((currency) => (
                  <option key={currency?.id} value={currency?.id}>
                    {currency?.name} ({currency?.symbol})
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='px-3 py-3 mb-1 bg-p-wh border-hf rounded-full text-2xl  text-s-bk rotate-90 lg:rotate-0'>
            <HiOutlineArrowNarrowRight />
          </div>
          <div className=' w-full flex  =flex-col gap-2'>
            <label className='text-p-bk text-base font-pin'>To</label>
            <div className='flex justify-between items-center w-full h-12  rounded-lg border-t-bk border-hf'>
              {/* <input
                  type="number"
                  className="focus:outline-none focus:ring focus:b-mc w-full px-2 h-11 rounded-lg relative"
                  name="to"
                  value={inputs.to}
                  onChange={handleChange}
                  required
                /> */}
              <p className='px-2'>
                {inputs.from !== ''
                  ? Number(inputs.from * exchangeRate?.price).toFixed(2)
                  : '0.00'}{' '}
              </p>
              <select
                name='to_currency'
                className='py-2 focus:outline-none focus:ring focus:b-mc h-11 pr-4 rounded-lg'
                value={
                  //   inputs.to_currency
                  //     ? inputs.to_currency
                  //     : (inputs.to_currency = defaultCurrencyQuote)
                  // }
                  inputs.to_currency
                }
                onChange={handleChange}
                required
              >
                {currencys?.map((currency) => (
                  <option key={currency?.id} value={currency?.id}>
                    {currency?.name} ({currency?.symbol})
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className='grid md:grid-cols-2 gap-6 lg:gap-[100px] w-full items-end'>
          <div className='flex flex-row gap-2 w-full text-s-bk bg-b-mct px-4 py-[10px] rounded'>
            <span className='text-2xl text-b-mc'>
              <RiInformationFill />
            </span>

            <p className='text-xs'>
              The converter uses the current loyaltyview system rate.
            </p>
          </div>

          <button
            className='text-p-wh px-4 py-2.5 w-full font-semibold bg-b-mc rounded disabled:bg-b-mct'
            disabled={isSubmitting}
          >
            Trade Direct{' '}
            {isSubmitting && (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
                className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
              />
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
export default CurrencyConverter;
